window.addSlidesToProductModal = function (slidesSrcArray, productId = null) {
  const productModal = document.querySelector("product-modal");
  if (!productModal || !Array.isArray(slidesSrcArray)) return;

  const ratio = ((1539 / 1946) * 100).toFixed(10);
  const mainTrack = productModal.querySelector(".product-media-modal__media-list");
  const thumbsTrack = productModal.querySelector(".embla-thumbs__container");
  const MAX_SLIDES = 6;

  Array.from(mainTrack.children)
    .filter(li => li.dataset.mediaId && li.dataset.mediaId.startsWith('dynamic-'))
    .forEach(el => el.remove());

  Array.from(thumbsTrack.children)
    .filter(li => li.dataset.mediaId && li.dataset.mediaId.startsWith('dynamic-'))
    .forEach(el => el.remove());

  const newSlidesHtmlModal = slidesSrcArray
    .map((src, index) => {
      const mediaId = `dynamic-${index}`;
      return `
        <li class="hidden w-full h-full overflow-hidden opacity-100 product-media-modal__media-item first:block animate-fade-in" data-media-id="${mediaId}">
          <zoom-image data-media-type="image" class="flex flex-col items-center justify-center w-full h-full">
            <div class="relative flex-initial w-full h-full" style="--aspect-ratio:1.3; max-width:calc((100vh - 6.25rem) * var(--aspect-ratio)); max-height:calc(100vw / var(--aspect-ratio));">
              <img class="absolute inset-0 object-contain w-full h-full product-media-modal__media-item-img" src="${src}" alt="Book preview" loading="lazy" width="1500" height="1125" data-media-id="${mediaId}">
            </div>
          </zoom-image>
        </li>
      `.trim();
    })
    .join("");

  const newThumbsHtmlModal = slidesSrcArray
    .map((src, index) => {
      const mediaId = `dynamic-${index}`;
      const prodIdAttr = productId ? `data-product-id="${productId}"` : "";
      return `
        <li data-media-id="${mediaId}" ${prodIdAttr} class="embla-thumbs__slide" style="--pb-ratio:${ratio}%">
          <button type="button" data-media-id="${mediaId}" aria-label="Go to item ${index + 1}">
            <img src="${src}" alt="Book preview thumbnail" width="208" height="156" loading="lazy" class="product-media-slider__media-thumb">
          </button>
        </li>
      `.trim();
    })
    .join("");

  mainTrack.insertAdjacentHTML("afterbegin", newSlidesHtmlModal);
  thumbsTrack.insertAdjacentHTML("afterbegin", newThumbsHtmlModal);

  const existingSlides = Array.from(mainTrack.querySelectorAll(".product-media-modal__media-item"));
  const existingThumbs = Array.from(thumbsTrack.querySelectorAll(".embla-thumbs__slide"));
  const totalSlides = existingSlides.length + slidesSrcArray.length;
  const toHideCount = totalSlides > MAX_SLIDES ? totalSlides - MAX_SLIDES : 0;

  for (let i = totalSlides - toHideCount; i < totalSlides; i++) {
    if (existingSlides[i]) existingSlides[i].classList.add("hidden");
    if (existingThumbs[i]) existingThumbs[i].classList.add("hidden");
  }

  if (productModal.thumbnailsSlider && typeof productModal.thumbnailsSlider.reInit === "function") {
    productModal.thumbnailsSlider.reInit();
  } else {
    productModal.setupSlider();
  }
};

class ProductModal extends ModalDialog {
  constructor() {
    super();

    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
  }

  setupSlider() {
    if (this.thumbnailsSlider) {
      return;
    }
    const OPTIONS_THUMBS = {
      containScroll: "keepSnaps",
      align: "center",
      dragFree: true,
    };

    this.thumbnailsViewport = this.querySelector(".embla-thumbs__viewport");
    this.thumbnailsSlider = EmblaCarousel(
      this.thumbnailsViewport,
      OPTIONS_THUMBS
    );

    this.setupThumbHandlers = this.setupThumbHandlers.bind(this);

    this.thumbnailsSlider
      .on("init", this.setupThumbHandlers)
      .on("reInit", this.setupThumbHandlers)
      .on("destroy", this.cleanup.bind(this));
  }

  cleanup() {
    if (this.removeThumbBtnsClickHandlers) {
      this.removeThumbBtnsClickHandlers();
    }
  }

  addThumbBtnsClickHandlers() {
    const slidesThumbs = this.thumbnailsSlider
      .slideNodes()
      .map((slide) => slide.querySelector("button") || slide);      

    const thumbClickHandlers = slidesThumbs.map((el) => () => {
      if (window.pauseAllMedia) {
        window.pauseAllMedia();
      }
      this.showMedia(el.dataset.mediaId);
    });

    slidesThumbs.forEach((slideNode, index) => {
      slideNode.addEventListener("click", thumbClickHandlers[index], false);
    });

    return () => {
      slidesThumbs.forEach((slideNode, index) => {
        slideNode.removeEventListener(
          "click",
          thumbClickHandlers[index],
          false
        );
      });
    };
  }

  setupThumbHandlers() {
    this.cleanup();
    this.removeThumbBtnsClickHandlers = this.addThumbBtnsClickHandlers();
  }

  reInit(index) {
    this.thumbnailsSlider.reInit();
    if (typeof index === "number") {
      requestAnimationFrame(() => {
        this.thumbnailsSlider.scrollTo(index);
      });
    }
  }

  show(mediaId) {
    super.show();

    document.body.classList.add("overflow-hidden");

    this.setupSlider();

    this.showMedia(mediaId);
  }

  showMedia(mediaId) {
    if (!mediaId) {
      return;
    }
    const activeMediaItem = this.querySelector(
      `.product-media-modal__media-item[data-media-id="${mediaId}"]`
    );
    if (activeMediaItem) {
      activeMediaItem.parentElement.prepend(activeMediaItem);
      const zoom = activeMediaItem.querySelector("zoom-image");
      if (zoom) {
        zoom.show();
      }
    }

    const thumbs = this.thumbnailsSlider.slideNodes();
    const activeIndex = thumbs.findIndex(
      (el) => el.dataset.mediaId === mediaId
    );
    if (activeIndex !== -1) {
      this.thumbnailsSlider.scrollTo(activeIndex);
    }
    thumbs.forEach((el, index) => {
      if (index === activeIndex) {
        el.classList.add("embla-thumbs__slide--selected");
      } else {
        el.classList.remove("embla-thumbs__slide--selected");
      }
    });
  }

  setActiveMedia(mediaId) {}

  scrollToIndex(index) {}
}

customElements.define("product-modal", ProductModal);
